import { useStoreSelector } from "../../../../src/lib/store";
import { patchUi, uiStore } from "../store/uiStore";

/**
 * Pattern DSL editor. Draft + warnings live on `uiStore` so Apply / Grid→DSL
 * in labRuntime can read/write without a module bridge.
 */
export function DslPanel() {
  const open = useStoreSelector(uiStore, s => s.dslOpen);
  const draft = useStoreSelector(uiStore, s => s.dslDraft);
  const warnings = useStoreSelector(uiStore, s => s.dslWarnings);

  if (!open) {
    return null;
  }

  return (
    <section
      className="lab-panel flex shrink-0 min-w-0 flex-col gap-[0.45rem] rounded-md border border-lab-line bg-lab-panel p-[0.65rem]"
      id="dsl-panel"
    >
      <div className="flex shrink-0 flex-wrap items-baseline justify-between gap-2">
        <h2 className="m-0 text-[12px] font-semibold text-slate-100">Pattern DSL</h2>
        <span className="text-[0.8rem] text-lab-muted">Hybrid string · @directives + rows</span>
      </div>
      <textarea
        id="dsl"
        spellCheck={false}
        value={draft}
        onChange={event => patchUi({ dslDraft: event.target.value })}
        aria-label="Pattern DSL"
        className="h-40 w-full resize-y rounded border border-lab-line bg-lab-cell px-[0.65rem] py-[0.55rem] font-lab-mono text-[12px] leading-[1.45] text-slate-300 outline-none"
      />
      <pre className="m-0 min-h-[1.1em] whitespace-pre-wrap font-mono text-[0.7rem] text-amber-400/90">
        {warnings}
      </pre>
    </section>
  );
}
